import { render, staticRenderFns } from "./ProductionCodesSettings.vue?vue&type=template&id=1a0827fa&scoped=true&"
import script from "./ProductionCodesSettings.vue?vue&type=script&lang=js&"
export * from "./ProductionCodesSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0827fa",
  null
  
)

export default component.exports